<template>
  <div class="bg-gray-box text-tiny mr-2 pl-1">
    <b-row class="pt-3 pl-3 pr-3 pb-2">
      <b-col>
        <b>จำนวนรายการ</b>
      </b-col>
      <b-col class="d-flex justify-content-end">
        <b>{{ bill.orderCount | numeral("0,0") }}</b>
      </b-col>
    </b-row>
    <b-row class="pt-0 pl-3 pr-3 pb-2">
      <b-col sm="6">
        <b
          >รายได้ทั้งหมด
          <b-button
            class="btn-collapse mb-1"
            variant="link"
            size="sm"
            v-b-toggle:collapseIncome
          >
            <b-icon class="text-purple when-open" icon="chevron-down"></b-icon>
            <b-icon class="text-purple when-closed" icon="chevron-up"></b-icon>
          </b-button>
        </b>
      </b-col>
      <b-col sm="6" class="mt-1 d-flex justify-content-end">
        <b
          >฿
          {{ (bill.subtotal + bill.shippingCost) | numeral("0,0.00") }}
        </b>
      </b-col>
      <b-col>
        <b-collapse
          v-model="collapseIncome"
          class="collapse-shipping"
          id="collapseIncome"
        >
          <b-row class="pl-3">
            <b-col sm="6">
              <b class="text-gray">ค่าสินค้า</b>
            </b-col>
            <b-col sm="6" class="d-flex justify-content-end">
              <b class="text-gray">฿ {{ bill.subtotal | numeral("0,0.00") }}</b>
            </b-col>
            <b-col sm="6" class="mt-1">
              <b class="text-gray">ค่าขนส่ง</b>
            </b-col>
            <b-col sm="6" class="mt-1 d-flex justify-content-end">
              <b class="text-gray"
                >฿ {{ bill.shippingCost | numeral("0,0.00") }}</b
              >
            </b-col>
          </b-row>
        </b-collapse>
      </b-col>
    </b-row>
    <b-row class="pt-0 pl-3 pr-3 pb-2">
      <b-col sm="6">
        <b
          >ส่วนลดรวม
          <b-button
            class="btn-collapse mb-1"
            variant="link"
            size="sm"
            v-b-toggle:collapseDiscount
          >
            <b-icon class="text-purple when-open" icon="chevron-down"></b-icon>
            <b-icon class="text-purple when-closed" icon="chevron-up"></b-icon>
          </b-button>
        </b>
      </b-col>
      <b-col sm="6" class="mt-1 d-flex justify-content-end text-purple">
        <b
          >- ฿
          {{ bill.totalDiscount | numeral("0,0.00") }}
        </b>
      </b-col>
      <b-col>
        <b-collapse
          v-model="collapseDiscount"
          class="collapse-shipping"
          id="collapseDiscount"
        >
          <b-row class="pl-3">
            <b-col sm="6">
              <b class="text-gray">ส่วนลดจากแพลตฟอร์ม</b>
            </b-col>
            <b-col sm="6" class="d-flex justify-content-end">
              <b class="text-gray"
                >฿ {{ bill.platformDiscount | numeral("0,0.00") }}</b
              >
            </b-col>
            <b-col sm="6" class="mt-1">
              <b class="text-gray">ส่วนลดจากร้านค้า</b>
            </b-col>
            <b-col sm="6" class="mt-1 d-flex justify-content-end">
              <b class="text-gray"
                >- ฿ {{ bill.shopDiscount | numeral("0,0.00") }}</b
              >
            </b-col>
          </b-row>
        </b-collapse>
      </b-col>
    </b-row>
    <b-row class="pt-2 pl-3 pr-3 pb-2">
      <b-col>
        <b>รายได้สุทธิ</b>
      </b-col>
      <b-col class="d-flex justify-content-end">
        <b
          >฿
          {{
            (bill.subtotal +
              bill.shippingCost -
              bill.totalDiscount +
              bill.platformDiscount)
              | numeral("0,0.00")
          }}</b
        >
      </b-col>
    </b-row>
    <b-row class="pt-0 pl-3 pr-3 pb-2">
      <b-col sm="6">
        <b
          >ค่าใช้จ่าย
          <b-button
            class="btn-collapse mb-1"
            variant="link"
            size="sm"
            v-b-toggle:collapseFee
          >
            <b-icon class="text-purple when-open" icon="chevron-down"></b-icon>
            <b-icon class="text-purple when-closed" icon="chevron-up"></b-icon>
          </b-button>
        </b>
      </b-col>
      <b-col sm="6" class="mt-1 d-flex justify-content-end text-purple">
        <b
          >- ฿
          {{
            (bill.realShippingCost +
              bill.platformGP +
              bill.paymentFee +
              bill.paymentVATFee +
              bill.transferFee +
              bill.serviceCost)
              | numeral("0,0.00")
          }}
        </b>
      </b-col>
      <b-col>
        <b-collapse
          v-model="collapseFee"
          class="collapse-shipping"
          id="collapseFee"
        >
          <b-row class="pl-3">
            <b-col sm="6">
              <b class="text-gray">ค่าขนส่งจริง</b>
            </b-col>
            <b-col sm="6" class="d-flex justify-content-end">
              <b class="text-gray"
                >- ฿ {{ bill.realShippingCost | numeral("0,0.00") }}</b
              >
            </b-col>
            <b-col sm="7" class="mt-1 pr-0">
              <b class="text-gray">ค่า GP/ ค่าบริการแพลตฟอร์ม</b>
            </b-col>
            <b-col sm="5" class="mt-1 pl-0 d-flex justify-content-end">
              <b class="text-gray"
                >- ฿ {{ bill.platformGP | numeral("0,0.00") }}</b
              >
            </b-col>
            <b-col sm="6" class="mt-1">
              <b class="text-gray">ค่าธรรมเนียมการชำระ</b>
            </b-col>
            <b-col sm="6" class="mt-1 d-flex justify-content-end">
              <b class="text-gray"
                >- ฿ {{ bill.paymentFee | numeral("0,0.00") }}</b
              >
            </b-col>
            <b-col sm="7" class="mt-1 pr-0">
              <b class="text-gray">VAT ค่าธุรกรรมการชำระ</b>
            </b-col>
            <b-col sm="5" class="mt-1 pl-0 d-flex justify-content-end">
              <b class="text-gray"
                >- ฿ {{ bill.paymentVATFee | numeral("0,0.00") }}</b
              >
            </b-col>
            <b-col sm="6" class="mt-1">
              <b class="text-gray">ค่าบริการถอน</b>
            </b-col>
            <b-col sm="6" class="mt-1 d-flex justify-content-end">
              <b class="text-gray"
                >- ฿ {{ bill.transferFee | numeral("0,0.00") }}</b
              >
            </b-col>
            <b-col sm="6" class="mt-1">
              <b class="text-gray">ค่าบริการอื่นๆ</b>
            </b-col>
            <b-col sm="6" class="mt-1 d-flex justify-content-end">
              <b class="text-gray"
                >- ฿ {{ bill.serviceCost | numeral("0,0.00") }}</b
              >
            </b-col>
          </b-row>
        </b-collapse>
      </b-col>
    </b-row>
    <div class="text-purple pt-2 pb-3 pl-3 pr-3">
      <b-row>
        <b-col>
          <b>จำนวนที่ต้องได้รับ</b>
        </b-col>
        <b-col class="d-flex justify-content-end">
          <!-- <b>฿{{bill.amountReceive | numeral("0,0.00")}}</b> -->
          <b
            >฿
            {{
              (bill.subtotal +
                bill.shippingCost -
                bill.totalDiscount +
                bill.platformDiscount -
                (bill.realShippingCost +
                  bill.platformGP +
                  bill.paymentFee +
                  bill.paymentVATFee +
                  bill.transferFee +
                  bill.serviceCost))
                | numeral("0,0.00")
            }}</b
          >
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { BIcon } from "bootstrap-vue";
export default {
  name: "BillPanel",
  components: { BIcon },
  props: {
    bill: {
      type: Object,
      isRequired: true,
    },
  },
  data() {
    return {
      collapseIncome: true,
      collapseDiscount: true,
      collapseFee: true,
    };
  },
};
</script>

<style lang="scss" scoped>
.text-tiny {
  font-size: 14px;
}
.text-purple {
  font-weight: bold;
  color: #8a44c3;
}
</style>
